module.exports = __webpack_public_path__ + "3095b8e06819a6a81522754075d28a6e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-running-s.png
// module id = 2549
// module chunks = 0